/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-10 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { TextStyle, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field } from 'redux-form';

import { RenderChoice } from 'src/components/views/common/forms/render-choice';
import { RenderSelect } from 'src/components/views/common/forms/render-select';
import GrantPermissionsNotif from 'src/components/views/recommendation/grant-permissions-notif';

import { getShop, buildUpdateAppPermissionURL } from 'src/helpers';

import {
  RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_BASED_ON_TYPES,
  RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_DATE_RANGE
} from 'src/constants/recommendation';

type Props = WithI18nProps & {
  aimlPermission: boolean
};

type State = {
  calculatedBasedOnTypes: Array<{ value: string, label: string }>,
  dateRange: Array<{ value: string, label: string }>
};
class TrendingProducts extends Component<Props, State> {
  state = {
    calculatedBasedOnTypes: [],
    dateRange: []
  };

  componentWillReceiveProps(nextProps) {
    const { i18n, aimlPermission } = nextProps;

    const calculatedBasedOnTypes = RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_BASED_ON_TYPES.map(
      choice => {
        if (choice.value === 'purchase-events' && !aimlPermission)
          return {
            ...choice,
            label: (
              <div>
                <div>{i18n.translate(choice.label)}</div>
                <br />
                <GrantPermissionsNotif
                  permissionURL={buildUpdateAppPermissionURL(getShop())}
                  recommendationType="trending-products"
                />
              </div>
            ),
            disabled: true
          };
        return { ...choice, label: i18n.translate(choice.label) };
      }
    );
    const dateRange = RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_DATE_RANGE.map(item => ({
      ...item,
      label: i18n.translate(item.label)
    }));
    this.setState({ calculatedBasedOnTypes, dateRange });
  }

  render() {
    const { i18n } = this.props;
    const { calculatedBasedOnTypes, dateRange } = this.state;

    return (
      <div className="widget-details-block">
        <FormLayout>
          <Field
            name="calculatedBasedOn"
            component={RenderChoice}
            label={
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Recommendation.WidgetItem.calculatedBasedOn_Label')}
              </TextStyle>
            }
            choices={calculatedBasedOnTypes}
          />

          <Field
            name="rangeOfTime"
            component={RenderSelect}
            label={
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Recommendation.WidgetItem.rangeOfTime_Label')}
              </TextStyle>
            }
            options={dateRange}
          />
        </FormLayout>
      </div>
    );
  }
}

export default withI18n()(TrendingProducts);
